<template>
    <div class="phantom-container">
        <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
        <div class="nav">
            <!-- 左侧分类菜单 -->
            <div class="left-menu">
                <div class="menu-list">
                    <div v-for="item in categoryList" :key="item.type" class="menu-item"
                        :class="{ active: activeType === item.type }" @click="switchCategory(item.type)">
                        <span class="menu-icon">{{ getCategoryIcon(item.type) }}</span>
                        {{ item.label }}
                        <span class="menu-count" v-if="getCategoryCount(item.type) > 0">{{ getCategoryCount(item.type)
                            }}</span>
                    </div>
                </div>
            </div>

            <!-- 右侧产品卡片区域 -->
            <div class="product-wrap" ref="productWrap">
                <div class="product-grid">
                    <div class="product-card" v-for="(item, idx) in pageProductList" :key="idx">
                        <div class="card-img">
                            <el-image style="width: 100%; height: 100%;" :src="getImgUrl(item)"
                                :preview-src-list="previewSrcList" fit="contain" lazy />
                        </div>
                    </div>
                </div>

                <!-- Element UI 分页 -->
                <div class="pagination" v-if="total > 0">
                    <el-pagination background layout="prev, pager, next" :current-page="pageNum" :page-size="pageSize"
                        :total="total" @current-change="handlePageChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import PullDown from "@/components/home/pullDown.vue"

export default {
    props: {
        hidePullDown: {
            type: Boolean,
            default: false // 默认显示
        }
    },
    name: 'PhantomProduct',
    components: {
        PullDown,
    },
    data() {
        return {
            activeType: 'all',
            pageNum: 1,
            pageMaxRow: 3,
            realColumn: 4,

            categoryList: [
                { type: 'all', label: '所有产品' },
                { type: 'adult', label: '成人' },
                { type: 'children', label: '儿科' },
                { type: 'animal', label: '兽医' },
                { type: 'geometry', label: '几何' }
            ],
            adultImgs: [
                '1.jpg', '2.jpg', '3.jpg', '5.jpg', '6.png',
                '7.png', '8.png', '9.jpg', '10.jpg', '11.jpg',
                '12.jpg', '13.jpg', '15.png', '16.jpg', '17.jpg',
                '18.jpg', '19.jpg', '20.jpg', '21.jpg', '22.jpg',
                '23.jpg', '25.jpg', '26.png', '27.jpg', '28.jpg',
                '29.jpg', '30.jpg', '31.jpg', '32.jpg', '37.jpg',
                '38.jpg', '39.jpg', '50.png', '61.png', '62.jpg',
                '65.png', '66.jpg', '67.jpg', '68.png', '69.jpg',
                '70.jpg', '71.jpg', '73.jpg', '79.png', '80.jpg',
                '81.png', '83.png', '85.jpg', '87.jpg', '89.jpg',
                '90.png'
            ],
            childrenImgs: [
                'children1.jpg', 'children2.jpg', 'children3.jpg',
                'children5.jpg', 'children6.jpg', 'children7.jpg',
                'children8.jpg', 'children9.jpg', 'children11.jpg',
                'children12.jpg'
            ],
            animalImgs: [
                'animals1.png', 'animals2.jpg', 'animals3.jpg',
                'animals5.png', 'animals6.png'
            ],
            geometryImgs: [
                'geometry1.jpg', 'geometry2.jpg', 'geometry3.jpg',
                'geometry5.png'
            ]
        }
    },
    mounted() {
        this.computeColumn()
        window.addEventListener('resize', this.computeColumn)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.computeColumn)
    },
    computed: {
        allFilterList() {
            const { activeType, adultImgs, childrenImgs, animalImgs, geometryImgs } = this
            if (activeType === 'all') {
                return [...adultImgs, ...childrenImgs, ...animalImgs, ...geometryImgs]
            } else if (activeType === 'adult') {
                return adultImgs
            } else if (activeType === 'children') {
                return childrenImgs
            } else if (activeType === 'animal') {
                return animalImgs
            } else if (activeType === 'geometry') {
                return geometryImgs
            }
            return []
        },
        pageSize() {
            return this.pageMaxRow * this.realColumn
        },
        total() {
            return this.allFilterList.length
        },
        pageProductList() {
            const start = (this.pageNum - 1) * this.pageSize
            const end = start + this.pageSize
            return this.allFilterList.slice(start, end)
        },
        previewSrcList() {
            return this.pageProductList.map(name => this.getImgUrl(name))
        }
    },
    methods: {
        getImgUrl(name) {
            return require(`@/assets/phantom/${name}`)
        },
        getFileName(name) {
            return name.replace(/\.[^.]+$/, '')
        },
        getFileTag(name) {
            const ext = name.split('.').pop()
            return ext.toUpperCase()
        },
        getCategoryIcon(type) {
            const icons = {
                all: '📦',
                adult: '🧑',
                children: '👶',
                animal: '🐾',
                geometry: '📐'
            }
            return icons[type] || '📎'
        },
        getCategoryCount(type) {
            if (type === 'all') return this.total
            const map = {
                adult: this.adultImgs,
                children: this.childrenImgs,
                animal: this.animalImgs,
                geometry: this.geometryImgs
            }
            return (map[type] || []).length
        },
        computeColumn() {
            const wrapDom = this.$refs.productWrap
            if (!wrapDom) return
            const wrapWidth = wrapDom.clientWidth
            const cardMinWidth = 280
            const gap = 24
            let cols = Math.floor((wrapWidth + gap) / (cardMinWidth + gap))
            cols = Math.max(1, cols)
            if (cols !== this.realColumn) {
                this.realColumn = cols
                this.pageNum = 1
            }
        },
        switchCategory(type) {
            this.activeType = type
            this.pageNum = 1
        },
        handlePageChange(newPage) {
            this.pageNum = newPage

            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth' // smooth平滑滚动；去掉就是瞬间跳转
            })
        }
    }
}
</script>

<style scoped>
.phantom-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    padding: 0 20px 40px;
    margin-top: 100px;
    background: linear-gradient(160deg, #f0f4ff 0%, #fafcff 40%, #f5f7fb 100%);
}

/* ========== 导航区域 ========== */
.nav {
    width: 70%;
    display: flex;
    gap: 40px;
    align-items: flex-start;
}

/* ========== 左侧菜单 - 高级卡片风格 ========== */
.left-menu {
    width: 240px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    border-radius: 20px;
    padding: 24px 18px 20px;
    height: fit-content;
    box-shadow:
        0 4px 24px rgba(0, 0, 0, 0.04),
        inset 0 1px 0 rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(255, 255, 255, 0.6);
    transition: box-shadow 0.4s ease, transform 0.3s ease;
    position: sticky;
    top: 120px;
}

.left-menu:hover {
    box-shadow:
        0 12px 48px rgba(26, 92, 255, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.menu-list .menu-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 11px 14px;
    cursor: pointer;
    border-radius: 12px;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 500;
    color: #4a5568;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
}

.menu-item:last-child {
    margin-bottom: 0;
}

.menu-icon {
    font-size: 16px;
    flex-shrink: 0;
}

.menu-count {
    margin-left: auto;
    font-size: 11px;
    font-weight: 600;
    color: #8a9aa8;
    background: rgba(0, 0, 0, 0.04);
    padding: 1px 10px;
    border-radius: 12px;
    transition: all 0.3s ease;
}

.menu-item.active {
    background: linear-gradient(135deg, #eef4ff, #e0eaff);
    color: #1a5cff;
    font-weight: 600;
    box-shadow: 0 2px 12px rgba(26, 92, 255, 0.10);
}

.menu-item.active .menu-count {
    background: rgba(26, 92, 255, 0.12);
    color: #1a5cff;
}

.menu-item.active::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3.5px;
    height: 28px;
    background: linear-gradient(180deg, #1a5cff, #6b8eff);
    border-radius: 0 6px 6px 0;
}

.menu-item:hover:not(.active) {
    background: rgba(26, 92, 255, 0.05);
    color: #1a2a5c;
    transform: translateX(4px);
}

.menu-item:hover:not(.active) .menu-count {
    background: rgba(26, 92, 255, 0.08);
    color: #1a5cff;
}

/* ========== 右侧产品区域 ========== */
.product-wrap {
    flex: 1;
    min-width: 0;
}

/* ========== 产品网格 ========== */
.product-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 28px;
    margin-bottom: 48px;
}

/* ========== 产品卡片 - 精致升级 ========== */
.product-card {
    background: #ffffff;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    border: 1px solid rgba(255, 255, 255, 0.5);
    position: relative;
}

.product-card::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 20px;
    padding: 1px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.05));
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
}

.product-card:hover {
    transform: translateY(-8px) scale(1.005);
    box-shadow:
        0 20px 60px rgba(26, 92, 255, 0.10),
        0 4px 20px rgba(0, 0, 0, 0.04);
    border-color: rgba(26, 92, 255, 0.12);
}

.card-img {
    height: 230px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(145deg, #f8fafc, #eef1f5);
    padding: 16px;
    position: relative;
    overflow: hidden;
}

.card-img::before {
    content: '';
    position: absolute;
    top: -40%;
    left: -20%;
    width: 80%;
    height: 80%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.4), transparent 70%);
    pointer-events: none;
    border-radius: 50%;
}

.card-img :deep(.el-image) {
    border-radius: 10px;
    transition: transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.product-card:hover .card-img :deep(.el-image) {
    transform: scale(1.04);
}

/* ========== 分页组件 ========== */
.pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.pagination :deep(.el-pagination) {
    --el-pagination-bg-color: transparent;
    --el-pagination-button-bg-color: rgba(255, 255, 255, 0.7);
    --el-pagination-hover-color: #1a5cff;
}

.pagination :deep(.el-pagination .btn-prev),
.pagination :deep(.el-pagination .btn-next) {
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    transition: all 0.3s ease;
    width: 40px;
    height: 40px;
    margin: 0 4px;
}

.pagination :deep(.el-pagination .btn-prev:hover),
.pagination :deep(.el-pagination .btn-next:hover) {
    background: #ffffff;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    border-color: rgba(26, 92, 255, 0.15);
    color: #1a5cff;
}

.pagination :deep(.el-pagination .number) {
    background: rgba(255, 255, 255, 0.4);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border-radius: 12px;
    border: 1px solid transparent;
    font-weight: 500;
    transition: all 0.3s ease;
    min-width: 40px;
    height: 40px;
    line-height: 40px;
    margin: 0 3px;
    font-size: 14px;
}

.pagination :deep(.el-pagination .number:hover) {
    background: rgba(255, 255, 255, 0.8);
    border-color: rgba(26, 92, 255, 0.15);
    color: #1a5cff;
}

.pagination :deep(.el-pagination .number.active) {
    background: linear-gradient(135deg, #1a5cff, #4a7aff);
    color: #ffffff;
    border-color: transparent;
    box-shadow: 0 4px 20px rgba(26, 92, 255, 0.30);
    font-weight: 600;
    transform: scale(1.05);
}

.pagination :deep(.el-pagination .number.active:hover) {
    color: #ffffff;
}

/* 空状态时的分页隐藏 */
.pagination:has(:deep(.el-pagination .el-pager li:only-child)) {
    display: none;
}

/* ========== 响应式优化 ========== */
@media (max-width: 1024px) {
    .nav {
        width: 90%;
        gap: 24px;
    }

    .left-menu {
        width: 200px;
        padding: 18px 14px 16px;
        top: 100px;
    }
}

@media (max-width: 768px) {
    .nav {
        flex-direction: column;
        width: 95%;
        gap: 20px;
    }

    .left-menu {
        width: 100%;
        display: flex;
        flex-direction: column;
        position: static;
        padding: 16px 14px;
        backdrop-filter: blur(16px);
    }

    .menu-header {
        padding-bottom: 12px;
        margin-bottom: 10px;
    }

    .menu-title {
        font-size: 14px;
    }

    .menu-list {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
    }

    .menu-list .menu-item {
        flex: 1;
        min-width: 56px;
        justify-content: center;
        text-align: center;
        font-size: 12px;
        padding: 8px 10px;
        margin-bottom: 0;
        border-radius: 10px;
        gap: 4px;
    }

    .menu-icon {
        font-size: 14px;
    }

    .menu-count {
        display: none;
    }

    .menu-item.active::before {
        display: none;
    }

    .menu-item.active {
        background: linear-gradient(135deg, #eef4ff, #dce6ff);
    }

    .menu-item:hover:not(.active) {
        transform: none;
    }

    .product-grid {
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        gap: 16px;
        margin-bottom: 32px;
    }

    .card-img {
        height: 160px;
        padding: 10px;
    }

    .card-footer {
        padding: 10px 14px 12px;
    }

    .card-name {
        font-size: 11px;
        max-width: 65%;
    }

    .card-tag {
        font-size: 9px;
        padding: 1px 10px;
    }

    .phantom-container {
        padding: 0 12px 30px;
        margin-top: 80px;
    }

    .pagination :deep(.el-pagination .btn-prev),
    .pagination :deep(.el-pagination .btn-next) {
        width: 34px;
        height: 34px;
    }

    .pagination :deep(.el-pagination .number) {
        min-width: 34px;
        height: 34px;
        line-height: 34px;
        font-size: 13px;
    }
}

@media (max-width: 480px) {
    .product-grid {
        grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
        gap: 12px;
    }

    .card-img {
        height: 130px;
        padding: 8px;
    }

    .menu-list .menu-item {
        font-size: 11px;
        padding: 6px 8px;
        min-width: 44px;
    }
}

/* ========== 全局样式覆盖 ========== */
:deep .global-nav[data-v-5e75b752] {
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
    color: #0f3059;
    background: transparent;
}

/* ========== 滚动条美化 ========== */
.product-wrap::-webkit-scrollbar {
    width: 4px;
}

.product-wrap::-webkit-scrollbar-track {
    background: transparent;
}

.product-wrap::-webkit-scrollbar-thumb {
    background: rgba(26, 92, 255, 0.2);
    border-radius: 10px;
}

.product-wrap::-webkit-scrollbar-thumb:hover {
    background: rgba(26, 92, 255, 0.3);
}
</style>